/**
 * The signature status of a waiver object is a numerical code what that maps like this enum.
 */
export enum WAIVER_STATUS {
  UNSIGNED = 0,
  SIGNED   = 1,
}
